import { render, staticRenderFns } from "./loginCollege.vue?vue&type=template&id=388b9535&scoped=true&"
import script from "./loginCollege.vue?vue&type=script&lang=js&"
export * from "./loginCollege.vue?vue&type=script&lang=js&"
import style0 from "./loginCollege.vue?vue&type=style&index=0&id=388b9535&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388b9535",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
